import type { Ref } from 'vue';
import { useState } from 'nuxt/app';
import type { AxiosStatic } from 'axios';
import type { Chat } from '~/models/career/chat/type';
import { fetchChats, fetchChat, readMessages } from '~/models/career/chat/api';
import type { ChatMessageStatus } from '~/models/career/chatMessageStatus/type';
import { fetchChatMessageStatus } from '~/models/career/chatMessageStatus/api';

type CareerChatState = {
  chats: Chat[],
  chat: Chat,
  chatMessageStatus: ChatMessageStatus
};

export const useCareerChat = () => {
  const state: Ref<CareerChatState> = useState('CareerChatState', () => {
    return {
      chats: [] as Chat[],
      chat: {} as Chat,
      chatMessageStatus: {
        unreadCount: 0,
        unansweredCount: 0
      } as ChatMessageStatus
    };
  });

  return {
    state,
    setChats: (chats: Chat[]) => {
      const { state } = useCareerChat();
      state.value.chats = chats;
    },
    setChat: (chat: Chat) => {
      const { state } = useCareerChat();
      state.value.chat = chat;
    },
    setChatMessageStatus: (chatMessageStatus: ChatMessageStatus) => {
      const { state } = useCareerChat();
      state.value.chatMessageStatus = chatMessageStatus;
    },
    fetchChats: async (axios: AxiosStatic, params: any) => {
      const { state } = useCareerChat();
      const chats = await fetchChats(axios, params);
      state.value.chats = chats;
    },
    fetchChat: async (axios: AxiosStatic, chatId: number) => {
      const { state } = useCareerChat();
      const chat = await fetchChat(axios, chatId);
      state.value.chat = chat;
    },
    fetchChatMessageStatus: async (axios: AxiosStatic) => {
      const { state } = useCareerChat();
      const chatMessageStatus = await fetchChatMessageStatus(axios);
      state.value.chatMessageStatus = chatMessageStatus;
    },
    readMessages: async (axios: AxiosStatic, chatId: number) => {
      const { state } = useCareerChat();
      await readMessages(axios, chatId);
      const chat = await fetchChat(axios, chatId);
      state.value.chat = chat;
    }
  };
};
